<template>
  <div>

    <v-card elevation="0" outlined shaped tile style="top: 1px; z-index: 1; position: sticky">
      <v-row>
        <v-col cols="12" sm="12" md="2">
          <v-menu ref="menu" v-model="menu" :close-on-content-click="true" transition="scale-transition" offset-y
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="date" label="Fecha Seleccionada" prepend-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <!-- :allowedDates="allowedDates" -->
            <v-date-picker v-model="date" :allowedDates="allowedDates" @change="updateSelectedDate()"
              @update:picker-date="pickerUpdate($event)" no-title @input="menu = false" scrollable>
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="12" md="8" class="d-none d-md-flex d-lg-flex d-xl-flex">
          <v-btn-toggle tile shaped dense :color="this.$uvHelper.uiConfig().mainColor" group>
            <template v-for="(day, indexDay) in commingDays">
              <v-btn :key="indexDay" @click="updateSelectedDateSuggest(day.Date)"
                style="border-bottom: 1px solid #01579b">
                {{ day.Nombre }}
              </v-btn>
            </template>
          </v-btn-toggle>
        </v-col>
        <v-col v-if="false" class="text-right d-none d-md-flex d-lg-flex d-xl-flex" cols="12" sm="12" md="2">
          <v-btn @click="showFilters = true" class="mt-2" elevation="0" color="primary" dark><v-icon>mdi-filter</v-icon>
            filtros</v-btn>
        </v-col>
      </v-row>
      <div v-if="false" class="px-4">
        <v-autocomplete v-model="rvaSearched" :items="rvaList" :loading="isLoading" :search-input.sync="search"
          item-value="internalId" item-text="Nombre" class="mt-1 mb-n6" outlined dense hide-no-data hide-selected
          label="Buscar jugador" @input="selectRvaList()" prepend-icon="mdi-magnify" return-object></v-autocomplete>
      </div>
      <div v-if="false">
        <v-btn color="red" @click="
          showCancelados = !showCancelados;
        buildTimesData();
        " text>{{ showCancelados ? "Ocultar Cancelados" : "Ver Cancelados" }}</v-btn>
        <v-btn color="primary" @click="showSearchFolio = true" text>Busqueda por Folio</v-btn>

      </div>
    </v-card>
    <v-simple-table v-if="!loadingData" class="teeTimes" dense>
      <template>
        <thead>
          <tr style="border: 1px solid #d4d4d5">
            <th scope="col" width="8%" style="border-right: 1px solid #d4d4d5" class="text-left">
              Horarios
            </th>
            <th scope="col" width="23%" class="text-center"></th>
            <th scope="col" width="23%" class="text-center"></th>
            <th scope="col" width="23%" class="text-center"></th>
            <th scope="col" width="23%" class="text-center"></th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(time, index) in times">
            <tr v-show="display(time.time)" :key="index">
              <td scope="row" width="8%" v-bind:class="[passTimeClass(time.time)]" style="
                 
                  font-size: 18px;

                  cursor: pointer;
                ">
                {{ time.time }}
              </td>
              <template v-for="(slot, indexSlot) in TeeSheet.slots">
                <td data-label="Jugador" class="respon" :key="indexSlot" v-bind:class="[passTimeClass(time.time)]"
                  style="border-right: 1px solid #d4d4d5;" width="23%">
                  <template v-for="(player, indexPlayer) in time.slotPlayers[indexSlot]">
                    <v-card :key="indexPlayer" :class="String(
                      time.slotPlayers[indexSlot][indexPlayer]
                        .FolioReserva
                    ) + ((time.slotPlayers[indexSlot][indexPlayer].E == 'N') ? ' noShowCard' : '')
                      " elevation="0" v-show="showByFilter(
                        time.slotPlayers[indexSlot][indexPlayer]
                      )
                        " :color="rowColor(time.slotPlayers[indexSlot][indexPlayer])
                          " style="    margin-top: 15px; margin-bottom:8px;">
                      <v-card-text v-bind:style="{
                        color: rowTextColor(
                          time.slotPlayers[indexSlot][indexPlayer]
                        ),
                      }" class="mb-0 pb-0 pt-0">
                        <v-row>
                          <v-col cols="12" md="12" class="pb-0 pt-0" style="">
                            <div class="mb-0 text-truncate itemLabel" style="text-align: justify;">
                              <h4>{{
                                getNumSocio(time.slotPlayers[indexSlot][indexPlayer].Nom)
                                }}</h4>
                              <b>{{
                                time.slotPlayers[indexSlot][indexPlayer]
                                  .deda
                                  ? ""
                                  : ""
                              }}</b>
                            </div>
                          </v-col>

                          <v-col v-if="false" cols="12" md="12" class="pb-0 pt-0">
                            <div class="mb-0 text-truncate" style="text-align: justify">
                              {{
                                time.slotPlayers[indexSlot][indexPlayer]
                                  .cdtr
                                  ? time.slotPlayers[indexSlot][indexPlayer]
                                    .cdtr
                                  : time.slotPlayers[indexSlot][indexPlayer]
                                    .trfr
                              }}
                            </div>
                          </v-col>
                          <v-col v-if="
                            false
                          " cols="12" md="12" class="pb-0 pt-0">
                            <div class="mb-0 text-truncate" style="text-align: justify"></div>
                          </v-col>
                          <v-col v-if="
                            false
                          " cols="6" md="6" class="pb-0 pt-0">
                            <b>
                              {{
                                time.slotPlayers[indexSlot][indexPlayer]
                                  .FolioReserva
                              }}</b>
                          </v-col>
                          <v-col v-if="
                            false
                          " cols="6" md="6" class="pb-0 pt-0">
                            <b>
                              {{
                                time.slotPlayers[indexSlot][indexPlayer]
                                  .fvta
                              }}</b>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </template>

                  <v-btn v-bind:class="[pointerClass(time.time)]" large style=""
                    v-if="time.slotPlayers[indexSlot].length == 0" depressed block>
                    <v-icon v-if="!time.privado" x-small disabled>mdi-plus-circle-outline</v-icon>
                    <h6 v-if="time.privado">
                      {{ time.privado.Mtv ? time.privado.Mtv : "BLOQUEADO" }}
                    </h6>
                  </v-btn>
                </td>
              </template>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>


  </div>
</template>

<script>

import moment from "moment";
import Reserva from "@/Clases/Reserva";
import tarifaMixin from "@/mixins/tarifaMixin";
import rvaMixin from "@/mixins/rvaMixin";

export default {
  name: "booking",
  mixins: [tarifaMixin, rvaMixin],
  components: {

  },
  data() {
    return {
      temporadas: [],
      guessConfig: {},
      ConfigRva: null,
      cajeros: [],
      FolioNotFound: false,
      folioToFind: null,
      showSearchFolio: false,
      showBloqueoHora: false,
      showFilters: false,
      Filters: {
        grupo: [],
      },
      keyBloqueoHora: 0,
      bloquedTimes: {
        Motivo: "BLOQUEADO",
        input_date: moment(),
        status: 2,
        HoraInicial: "",
        HoraFinal: "",
        minDate: "06:00",
        maxDate: "23:01",
      },
      grupos: [],
      tiposJuego: [],
      Concierges: [],
      tarifaCombo: [],
      rvaSearched: null,
      isLoading: false,
      search: null,
      resGroup: false,
      showCancelados: false,
      dialogOptionRes: false,
      indexSheetForm: 1,
      indexSheetFormEdit: 2,
      dialog: false,
      dialogEdit: false,
      notifications: false,
      sound: true,
      widgets: false,
      menu: false,
      date: moment().format("YYYY-MM-DD"),
      TeeSheet: {
        slots: [0, 1, 2, 3],
      },
      availableDates: [],
      selectedTimeData: [],
      editData: [],
      editMode: false,
      selectedResItem: {},
      totalReservas: 0,
      totalPlayers: 0,
      totalProyectado: 0,
      totalCancelados: 0,
      totalPagados: 0,
      totalNoShow: 0,
      totalPendientes: 0,
      showAll: false,
      MainDepartamento: "",
      //data_clientes:[],
      confirmBook: false,
      transModal: false,
      input_date: moment(),
      actualDate: moment(),
      isAdmin: false,
      loadingData: false,
      isPreferedTime: false,
      selectedTarifa: "",
      compIndex: 0,
      actualListener: "",
      prefered: true,
      RsvaTransId: "",
      forceRecomputeCounter: 0,
      // Confirm:"",
      modalOpen: false,
      selectedPriceIndex: "",
      selectedTime: "",
      times: [],
      reservas: [],
      daysRules: [],
      initTime: new moment("06:00", "HH:mm"),
      endTime: new moment("18:00", "HH:mm"),
      configTime: {},
      intervalo: 10,
      Horarios: [],
      subcategorias: [],
      scrolledToLast: false,
      highlighted: {
        dates: [
          // Highlight an array of dates
          new Date(moment()),
          //new Date(2020, 0, 17),
          //new Date(2020, 0, 18)
        ],
      },
    }
  },
  props: ["isHotel", "isWeb"],
  methods: {
    getNumSocio(str) {
      const match = /\((.*?)\)/.exec(str);
      return match ? match[1] : str;
    },
    async init() {
      await this.getDaysRules();
      await this.getConfig();
      await this.getReservas();
      this.scrolledToLast = false;
      await this.buildTimesData();
    },
    showByFilter(item) {
      let show = true;
      if (this.Filters.grupo.length > 0) {
        if (this.Filters.grupo.includes(item.grp)) {
          show = true;
        } else {
          show = false;
        }
      }
      return show;
    },
    pickerUpdate(val) {
      let totalDay = moment(val, "YYYY-MM").daysInMonth();
      let weekDay = [];

      let disable_dates = [];
      let open_dates = [];

      this.daysRules.forEach((element) => {
        if (element.data === false) {
          disable_dates.push(element.date, "YYYY-MM-DD");
        } else {
          open_dates.push(element.date);
        }
      });

      let availableDates = [];

      let monthNow = moment().format("M");
      let monthSelected = moment(val).format("M");
      let day;

      if (monthNow == monthSelected) day = moment().format("D");
      else day = 1;

      for (let i = day; i <= totalDay; i++) {
        let date = moment()
          .month(val.split("-")[1] - 1)
          .date(i)
          .format("YYYY-MM-DD");
        if (
          !weekDay.includes(moment(date).day()) &&
          !disable_dates.includes(date)
        ) {
          if (date <= moment().add(90, 'days').format("YYYY-MM-DD")) {
            availableDates.push(date);

          }

        }

        if (weekDay.includes(moment(date).day()) && open_dates.includes(date)) {
          availableDates.push(date);
        }
      }
      this.availableDates = availableDates;
      this.allowedDates();
    },
    allowedDates(a) {
      return this.availableDates.includes(a);
    },
    updateSelectedDate() {
      this.loadingData = true;
      this.selectDate(this.date);
    },
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    },
    addCartRider() {
      if (this.cartRiderName !== "") {
        this.cartRiders.push({ name: this.cartRiderName });
        this.cartRiderName = "";
        if (this.transportation) {
          this.getTransportationData();
        }
      } else {
        this.$swal({
          icon: "error",
          title: "Cart Rider Name is required",
          text: "",
        });
      }
    },
    deleteCartRider(index) {
      this.cartRiders.splice(index, 1);
      //this.getTransportationData();
    },
    changePlayersNumber() {
      this.presentAlert = false;
      this.resetSelect();
      //this.players= [{name:'',email:'',phone:'',golfClub:false,side:"right",genero:'Man',shaft:'regular'}];
      if (this.players.length < this.playersNumber) {
        var i;
        for (i = this.players.length; i < this.playersNumber; i++) {
          this.players.push({
            name: "",
            email: "",
            phone: "",
            golfClub: false,
            side: "right",
            genero: "Man",
            shaft: "regular",
          });
        }
      } else if (this.players.length > this.playersNumber) {
        for (i = this.playersNumber; i < this.players.length; i) {
          this.players.pop();
        }
      }
      if (this.transportation) {
        this.getTransportationData();
      }
    },
    changeTrans(value) {
      //this.transportation = value;
      if (value == true) {
        this.transModal = true;
      } else {
        /*if(this.selectedPriceIndex === ""){
                this.$swal(
                    'Selecciona un horario',
                    'Selecciona un horario de juego antes de solicitar transportacion ',
                    'error'
                )
 
                document.getElementsByName('trans').forEach((element =>{
                    element.checked = false;
                }))
        }else if(this.transportation && this.selectedPriceIndex !== ""){
            if(this.isHotel){
                this.getTransportationData();
            }
            
        }*/
        this.Session = "";
        this.ApiToken = "";
        this.TotalTrans = 0;
        this.RowId = "";
        this.RsvaId = "";
        this.DuracionViaje = "";
        this.HtlPickup = "";
        this.PCGCPickup = "";
        //this.Confirm ="";
        this.transportation = value;
        this.tranindx++;
        /*this.$swal(
                'No se transportara a los jugadores',
                'La transportacion al campo de golf  no sera incluida en esta reserva ',
                'error'
            )*/
      }
    },
    changeHoyos() {
      this.resetSelect();
      (this.selectedTime = ""), (this.selectedPrice = ""), this.compIndex++;
      this.getTarifas();
    },
    changeAsGuest() {
      var $this = this;
      if (!this.changeGuest) {
        let pNumber = 1;
        this.players.forEach((element, index) => {
          if (index !== 0 && element.name === "") {
            element.name = this.players[0].name ?? null;
            element.email = this.players[0].email ?? null;
            element.phone = this.players[0].phone ?? null;
            pNumber++;
          }
        });
      } else {
        this.players.forEach(function (element, index) {
          if (index != 0) {
            element.name = "";
            element.email = "";
            element.phone = "";
          }
        });
      }
    },
    rowColor: function (data) {
      /*let color =
        data.E == "R"
          ? data.colr == "D"
            ? "blue"
            : data.colr == "M"
              ? "orange"
              : data.colr || "blue"
          : data.E == "P"
            ? "green"
            : "red";
      if (data.E == "N") {
        return "#9e9e9e36"
      }
      if (data.deda) {
        return "#9d0b00";
      }*/

      return "blue";
    },
    rowTextColor(data) {
      let color =
        data.colr == "D"
          ? "white"
          : data.colr == "M"
            ? "white"
            : this.$uvHelper.invertColor(data.colr);
      if (data.E == "P") {
        return "white";
      }
      if (data.deda) {
        return "white";
      }
      return color;
    },

    setSelectedTime(key, time, idTarifa, mnd, prefered) {
      //alert(key + ' ' + time + ' ' + total);

      this.selectedPriceIndex = key;
      this.selectedTime = time;
      this.moneda = mnd;
      this.selectedTarifa = idTarifa;
      this.isPreferedTime = prefered;
      this.clienDataModal = true;
      this.step = "sendPerData";
      this.changeAsGuest();
      this.$nextTick(() => {
        this.changeGuest = null;
        //document.getElementById("dataClient").scrollIntoView();
      });
    },
    selectDate(arg) {
      let oldDate = this.input_date.format('YYYY-MM-DD');
      this.killListener(oldDate);
      this.tarifas = []
      if (this.playersNumber == 0) {
        this.presentAlert = true;
      }
      this.loadingTarifas = true;
      this.input_date = moment(arg);
      this.resetSelect();
      (this.selectedTime = ""), (this.selectedPrice = "");
      this.openDateInput = false;
      this.init()

    },
    setInitialDate() {
      this.input_date.format("YYYY-MM-DD");
      let aux = false;
      this.daysRules.forEach((element) => {
        if (element.data.Abre && element.data.Cierra) {
          if (this.input_date.format("YYYY-MM-DD") === element.date) {
            this.initTime = new moment(element.data.Abre, "HH:mm:ss");
            this.endTime = new moment(element.data.Cierra, "HH:mm:ss");
            aux = true;
          }
        }
      });
      if (!aux) {
        this.initTime = this.configTime.initTime;
        this.endTime = this.configTime.endTime;
      }
    },
    killListener(date) {
      this.$store.getters.getFirebaseApp.database.ref("Reservas/" + date).off();
    },
    selectPaid(value) {
      this.$store.commit("setTypePaid", value);
      this.getTarifas();
    },
    resetSelect() {
      this.selectedPriceIndex = "";
      this.isPreferedTime = false;
      document.getElementsByName("trans").forEach((element) => {
        element.checked = false;
      });
      this.$store.commit("setPriceSelected", 0);
      this.$store.commit("setMndSelected", "");
    },
    passTimeClass(time) {
      let pointer = "";

      if (
        this.actualDate.format("YYYY-MM-DD HH:mm") >
        moment(
          this.input_date.format("YYYY-MM-DD") + time,
          "YYYY-MM-DD HH:mm"
        ).format("YYYY-MM-DD HH:mm")
      ) {
        //this.$pgsHelper.log(this.actualDate.format('YYYY-MM-DD HH:mm'));

        pointer = "cardDisabledTeeSheet";
        //pointer = "";
      }

      return pointer;
    },
    pointerClass: function (time) {
      let pointer = "";

      if (
        this.actualDate.format("YYYY-MM-DD HH:mm") >
        moment(
          this.input_date.format("YYYY-MM-DD") + time,
          "YYYY-MM-DD HH:mm"
        ).format("YYYY-MM-DD HH:mm")
      ) {
        //this.$pgsHelper.log(this.actualDate.format('YYYY-MM-DD HH:mm'));

        //pointer = "cardDisabled";
        pointer = "";
      }

      return pointer;
    },

    display: function (time) {
      let show = true;

      if (
        this.actualDate.format("YYYY-MM-DD HH:mm") >
        moment(
          this.input_date.format("YYYY-MM-DD") + time,
          "YYYY-MM-DD HH:mm"
        ).format("YYYY-MM-DD HH:mm")
      ) {
        show = false;
      }

      if (this.showAll) {
        show = true;
      }

      return true;
    },
    async getHorarios() {
      //const data = await this.$store.getters.getFirebaseApp.database.ref("Golf/Tarifas/Horarios").once("value");
      const data = await this.$store.getters.getFirebaseApp.database
        .ref("RVA/Tarifas/" + this.MainDepartamento + "/Horarios")
        .once("value");

      if (!data.exists()) {
        return false;
      }
      let arrayHorarios = Object.entries(data.val());
      var $this = this;
      arrayHorarios.forEach(function (element) {
        $this.Horarios.push({ id: element[0], ...element[1] });
      });
    },
    async testRealTime() {
      const data = await this.$store.getters.getFirebaseApp.database
        .ref("Configuracion/Reservas/EmailCCO")
        .once("value");
      this.$uvHelper.log(data.val());
    },
    async getTransportationData() {
      /* 
        Obiene la informacion de la transportacion para la reserva
        */
      let data = {
        PaxNumber: this.players.length + this.cartRiders.length,
        hotelCode: this.$route.params.user.tokenResult.claims.Code,
        Prefered: this.isPreferedTime,
        Fecha:
          this.input_date.format("YYYY-MM-DD") +
          "_" +
          moment(this.selectedTime, "HH:mm").format("HH:mm:ss"),
      };
      this.loadingData = true;
      //var getTransportation = this.$store.getters.getFirebaseApp.fba.call('Golf-Reservas-transportationAvailability');
      return await this.$store.getters.getFirebaseApp.fba
        .call("Golf-Reservas-transportationAvailability", data, {})
        .then((result) => {
          this.Session = result.data.data.Session;
          this.ApiToken = result.data.data.ApiToken;
          this.TotalTrans =
            this.typePaid === 1
              ? this.playersNumber >= 4
                ? 0
                : this.addOn.transport.Precio
              : this.playersNumber >= 2
                ? 0
                : this.addOn.transport.Precio;
          this.RowId = result.data.data.RowId;
          this.RsvaTransId = result.data.data.RsvaTransId;
          this.rawDuracionViaje = result.data.data.DuracionViaje;
          this.DuracionViaje = moment(
            result.data.data.DuracionViaje,
            "HH:mm:ss"
          ).format("HH [Hrs] : mm [Min].");
          this.HtlPickup = moment(
            result.data.data.HtlPickup,
            "YYYY-MM-DD_HH:mm:ss"
          ).format(" DD-MMM-YYYY HH:mm ");
          this.PCGCPickup = moment(
            result.data.data.PCGCPickup,
            "YYYY-MM-DD_HH:mm:ss"
          ).format(" DD-MMM-YYYY HH:mm ");
          //this.Confirm= result.data.data.Confirm;
          this.loadingData = false;
        })
        .catch((error) => {
          this.$uvHelper.log(error);
        });
    },
    async getTiposJuego() {
      const data = await this.$store.getters.getFirebaseApp.database
        .ref("RVA/Tarifas/" + this.MainDepartamento + "/Modalidades")
        .once("value");
      let arrayTipos = Object.entries(data.val());
      var $this = this;
      arrayTipos.forEach((element) => {
        $this.tiposJuego.push({
          id: element[0],
          codigo: element[1]["Codigo"],
          nombre: element[1]["Nombre"],
        });
        if (element[1]["Codigo"] == "18HOLES") {
          this.hoyos = element[0];
        }
      });
    },
    async getTemporadas() {
      /*
         Obtiene las temporadas existentes en la db
        */
      const data = await this.$store.getters.getFirebaseApp.database
        .ref("RVA/Tarifas/" + this.MainDepartamento + "/Temporadas")
        .once("value");
      if (!data.exists()) {
        return false;
      }
      let arrayTarifas = Object.entries(data.val());
      arrayTarifas.forEach((element) => {
        if (element[1].Activo) {
          this.temporadas.push({ id: element[0], ...element[1] });
        }
      });
    },
    async getAddons() {
      /*
         Obtiene las temporadas existentes en la db
        */
      let addons = this.$store.getters.getRVACatalogo;
      /*const dataExt = await this.$store.getters.getFirebaseApp.database.ref("Golf/Addons/ExtraRidder").once("value");
        let arrayExt =  dataExt.val();*/
      this.addOn.cartRider = addons.GOLFRIDDER; //arrayExt;

      /*const dataGb = await this.$store.getters.getFirebaseApp.database.ref("Golf/Addons/GolfClub").once("value");
        let arrayGb =  dataGb.val();*/
      this.addOn.golfClub = addons.GOLFCLUB; //arrayGb;

      /*const dataTr = await this.$store.getters.getFirebaseApp.database.ref("Golf/Addons/Transport").once("value");
        const arrayTr = await dataTr.val();*/
      this.addOn.transport = addons.TRANSPORT;
      /*arrayTarifas.forEach((element)=>{
           this.temporadas.push({id:element[0],...element[1]}); 
        });
 
        const dataGb = await this.$store.getters.getFirebaseApp.database.ref("Addons/GolfClub").once("value");
        let arrayTarifas =  Object.entries(data.val());
        arrayTarifas.forEach((element)=>{
           this.temporadas.push({id:element[0],...element[1]}); 
        });*/
    },
    async getReservas() {
      /*
            Se obtiene las disponibilidad por dia y la cantidad de personas reservadas en esos dias
        */
      let date = this.input_date.format("YYYY-MM-DD");
      this.killListener(this.actualListener);

      this.$store.getters.getFirebaseApp.database
        .ref("RVA/Reservas/" + this.MainDepartamento + "/" + date)
        .on("value", (snapshot) => {
          if (snapshot.exists()) {
            this.reservas = [];
            let arrayReservas = snapshot.val();
            this.reservas = Reserva.parseAvailabilityData(arrayReservas);
            this.totalPlayers = 0;
            this.totalCancelados = 0;
            this.totalPagados = 0;
            this.totalNoShow = 0;
            this.totalPendientes = 0;
            this.reservas.forEach((element) => {
              this.totalPlayers =
                this.totalPlayers +
                (element.rvsData ? element.rvsData.length : 0);
              if (element.Rvs) {
                this.totalReservas =
                  this.totalReservas + Object.keys(element.Rvs).length;
              }
              if (element.rvsData) {
                element.rvsData.forEach((ply) => {
                  if (ply.E) {
                    if (ply.E == "P") {
                      this.totalPagados++;
                    }
                    if (ply.E == "R") {
                      this.totalPendientes++;
                    }
                    if (ply.E == "C") {
                      this.totalCancelados++;
                    }
                    if (ply.E == "N") {
                      this.totalNoShow++
                    }
                  }
                });
              }
            });
          } else {
            this.reservas = [];
            this.totalPlayers = 0;
            this.totalCancelados = 0;
            this.totalPagados = 0;
            this.totalNoShow = 0
            this.totalPendientes = 0;
          }
          this.buildTimesData();
        });

      this.actualListener = date;
    },
    async getDaysRules() {
      this.$store.getters.getFirebaseApp.database
        .ref("RVA/Configuracion/" + this.MainDepartamento + "/Calendario")
        .on("value", (snapshot) => {
          if (snapshot.exists()) {
            this.daysRules = [];
            if (snapshot.val().Fechas_Especiales) {
              let arrayCalendar = Object.entries(
                snapshot.val().Fechas_Especiales
              );
              arrayCalendar.forEach((element) => {
                this.daysRules.push({ date: element[0], data: element[1] });
              });

              //ordena las reglas por fecha
              this.daysRules.sort(function compare(a, b) {
                return a.date - b.date;
              });
              this.configTime.initTime = new moment(
                snapshot.val().Hora_Apertura,
                "HH:mm:ss"
              );
              this.configTime.endTime = new moment(
                snapshot.val().Hora_Cierre,
                "HH:mm:ss"
              );
            } else {
              this.configTime.initTime = new moment(
                snapshot.val().Hora_Apertura,
                "HH:mm:ss"
              );
              this.configTime.endTime = new moment(
                snapshot.val().Hora_Cierre,
                "HH:mm:ss"
              );
              this.daysRules = [];
            }
          } else {
            this.daysRules = [];
          }
        });
    },
    buildTimesData() {
      /*
            Genera el array conteniendo cada horario disponible para reserva en un intervalo de 10 minutos desde la hora inicial y la hora final
        */
      try {
        this.initTime = "";
        this.endTime = "";
        this.setInitialDate();
        let initTim = new moment(this.initTime.format("HH:mm"), "HH:mm");
        let endTime = new moment(this.endTime.format("HH:mm"), "HH:mm");

        let auxDate = initTim;
        this.times = [];
        this.totalProyectado = 0;
        var i;
        /*para cada uno de los horarios armados se asignan los datos necesarios*/
        for (i = 0; auxDate.format("HH:mm") <= endTime.format("HH:mm"); i++) {
          var idTarifa;
          var precio;
          var idTarifaGlobal = "";
          var precioGlobal = "";
          let personas = 0;
          let privado = false;

          let players = [];
          let slotPlayers = [];
          //
          this.totalProyectado += this.TeeSheet.slots.length;
          this.TeeSheet.slots.forEach((slot) => {
            slotPlayers[slot] = [];
          });
          /*en caso de que tengan reservas en ese Horario y dia seleccionado se agregan a los datos*/
          this.reservas.forEach((element) => {
            let time = new moment(element.time, "HH:mm:ss");
            if (time.format("HH:mm") == auxDate.format("HH:mm")) {
              players = element.rvsData ? element.rvsData : [];
              let slotPlayerNum = 0;
              players.forEach((player) => {
                if (
                  player.E == "R" ||
                  player.E == "P" ||
                  player.E == "N" ||
                  this.showCancelados == true
                ) {
                  slotPlayers[slotPlayerNum].push(player);
                  if (slotPlayerNum == this.TeeSheet.slots.length - 1) {
                    slotPlayerNum = 0;
                  } else {
                    slotPlayerNum++;
                  }
                }
              });
              let rvs = element.Rvs ? element.Rvs : {};
              let rvsArray = Object.entries(rvs);
              rvsArray.forEach((res) => {
                if (res[1].Pys) {
                  res[1].Pys.forEach((ply) => {
                    if (ply.E == "R" || ply.E == "P") {
                      personas++;
                    }
                  });
                }
              });

              //personas = element.PAX;

              privado = element.Privado ? element.Privado : false;
            }
          });

          /* se agregan al array*/
          this.times.push({
            time: auxDate.format("HH:mm"),
            tarifaId: idTarifa,
            tarifaIdGlobal: idTarifaGlobal,
            precioGlobal: precioGlobal,
            precio: precio,
            personas: personas,
            privado: privado,
            players: players,
            slotPlayers: slotPlayers,
            prefered: false,
          });
          auxDate = auxDate.add(10, "minutes");
        }

        this.loadingData = false;
        if (!this.scrolledToLast) {
          setTimeout(() => {
            this.scrollToLastDisabled();
          }, 500);
        }
      } catch (e) {
        this.loadingData = false;
      }
    },
    scrollToLastDisabled() {
      this.$nextTick(() => {
        const elements = document.querySelectorAll(".cardDisabledTeeSheet");
        if (elements.length > 0) {
          const lastElement = elements[elements.length - 1];
          lastElement.scrollIntoView({ behavior: "smooth", block: "center" });
          this.scrolledToLast = true;
        }
      });
    },
    updateSelectedDateSuggest(day) {
      this.loadingData = true;
      this.date = day;
      this.selectDate(this.date);
    },
    validation() {
      var valid = true;

      if (this.selectedPriceIndex === "") {
        valid == false;
        this.errors.time = true;
      } else {
        this.errors.time = false;
      }
      let aux = 0;
      this.players.forEach((element) => {
        if (element.name == "" || element.email == "") {
          aux++;
        }
      });

      if (aux > 0) {
        valid = false;
        this.errors.players = true;
      } else {
        this.errors.players = false;
      }

      if (this.typePaid === 1 && this.promotionalCode === "") {
        valid = false;
        this.errors.code = true;
      } else {
        this.errors.code = false;
      }

      return valid;
    },
    async getConfig() {
      const conf = await this.$store.getters.getFirebaseApp.database
        .ref("RVA/Configuracion/Golf")
        .once("value");
      let resultConf = conf.val();
      this.ConfigRva = resultConf;
    },


  },
  computed: {
    commingDays() {
      try {
        let disable_dates = [];
        let open_dates = [];
        let weekDay = [];
        this.daysRules.forEach((element) => {
          if (element.data === false) {
            disable_dates.push(element.date, "YYYY-MM-DD");
          } else {
            open_dates.push(element.date);
          }
        });
        let numberToShow = 4;
        let days = [];

        let actual = moment();
        for (var i = 0; days.length <= numberToShow; i++) {
          let hoy = moment();
          let isToday = false;
          if (actual.format("YYYY-MM-DD") == hoy.format("YYYY-MM-DD")) {
            isToday = true;
          }

          if (!weekDay.includes(actual.day())) {
            days.push({
              Nombre: isToday ? "Hoy" : actual.format("ddd - DD"),
              Date: actual.format("YYYY-MM-DD"),
            });
          }

          if (
            weekDay.includes(actual.day()) &&
            open_dates.includes(actual.format("YYYY-MM-DD"))
          ) {
            days.push({
              Nombre: isToday ? "Hoy" : actual.format("ddd - DD"),
              Date: actual.format("YYYY-MM-DD"),
            });
          }
          actual.add(1, "days");
        }

        return days;
      } catch (e) {
        return [];
      }
    },
    rvaList() {
      let data = [];
      if (this.reservas) {
        try {
          this.reservas.forEach((teeTime) => {
            if (teeTime.rvsData) {
              teeTime.rvsData.forEach((player) => {
                player.internalId = player.id + "||" + player.Cta;
                if (player.E == "R" || player.E == "P") {
                  player.Nombre = player.Nom + " TeeTime:" + teeTime.time;
                  data.push(player);
                }
              });
            }
          });
          let dataFilter = [];
          if (this.search != "" && this.search) {
            dataFilter = data.filter((acc) => {
              if (
                acc?.Nombre?.toUpperCase().includes(this.search.toUpperCase())
              ) {
                return true;
              } else {
                return false;
              }
            });
          }
          return dataFilter;
        } catch (e) {
          return data;
        }
      } else {
        return data;
      }
    },
  },
  async mounted() {
    this.MainDepartamento = "Golf"
    this.loadingData = true;
    this.init()
  },
  beforeMount() {

  },
  created() {
    setInterval(() => {
      let fecha = new moment();
      this.actualDate = fecha; //.format("YYYY-MM-DD HH:mm:ss");
    }, 1000);
  },
};
</script>
<style>
.noShowCard {
  background: repeating-linear-gradient(-45deg, #fff 0 20px, #c8c8c8 0 40px) !important;
}

.cardDisabledTeeSheet {
  background: #607d8b59 !important;
}

.cardDisable .button {
  background: unset;
}

.input input {
  border-bottom: 1px solid black;
  width: 100%;
}

@keyframes scrolling {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-100%);
  }
}

@media only screen and (max-width: 600px) {
  .paidDescription {
    display: none !important;
  }
}

.vdp-datepicker__calendar {
  width: 100% !important;
}

.itemLabel {
  max-width: 100%;
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (max-width: 768px) {
  .paidDescription {
    display: none !important;
  }

  .itemLabel {
    max-width: 100%;
  }
}

@media only screen and (max-width: 768px) {
  .itemLabel {
    max-width: 100%;
  }
}

@media (min-width: 1281px) {
  .itemLabel {
    max-width: 100%;
  }

  .itemMiddleLabel {
    max-width: 125px;
  }
}

/* 
  ##Device = Laptops, Desktops
  ##Screen = B/w 1025px to 1280px
*/

@media (min-width: 1025px) and (max-width: 1280px) {
  .itemLabel {
    max-width: 100%;
  }

  .itemMiddleLabel {
    max-width: 75px;
  }
}

.teeTimes table {
  border: 1px solid #ccc;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
}

.teeTimes table caption {
  font-size: 1.5em;
  margin: 0.5em 0 0.75em;
}

.teeTimes table tr {
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  padding: 0.35em;
}

.teeTimes table th,
.teeTimes table td {
  padding: 0.625em;
  text-align: center;
  padding: 12px !important;
}

.teeTimes table th {
  font-size: 0.85em;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

@media screen and (max-width: 600px) {
  .teeTimes table {
    border: 0;
  }

  .teeTimes table caption {
    font-size: 1.3em;
  }

  .teeTimes table thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  .teeTimes table tr {
    border-bottom: 3px solid #ddd;
    display: block;
    margin-bottom: 0.625em;
    display: table;
  }

  .teeTimes table td.respon {
    display: table-row;
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: 0.8em;
    text-align: right;
    height: auto !important;
    width: 100% !important;
    padding: 5px !important;
  }

  .teeTimes table td .v-card {

    min-width: 78px;
    padding: 0 19.5555555556px;
    margin-top: 25px;
  }

  .teeTimes table td:last-child {
    border-bottom: 0;
  }

}
</style>
